/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpgatesWebhookRequest
 */
export interface UpgatesWebhookRequest {
    /**
     * 
     * @type {string}
     * @memberof UpgatesWebhookRequest
     */
    event?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpgatesWebhookRequest
     */
    ids?: Array<string>;
}

/**
 * Check if a given object implements the UpgatesWebhookRequest interface.
 */
export function instanceOfUpgatesWebhookRequest(value: object): value is UpgatesWebhookRequest {
    return true;
}

export function UpgatesWebhookRequestFromJSON(json: any): UpgatesWebhookRequest {
    return UpgatesWebhookRequestFromJSONTyped(json, false);
}

export function UpgatesWebhookRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgatesWebhookRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'event': json['event'] == null ? undefined : json['event'],
        'ids': json['ids'] == null ? undefined : json['ids'],
    };
}

export function UpgatesWebhookRequestToJSON(json: any): UpgatesWebhookRequest {
    return UpgatesWebhookRequestToJSONTyped(json, false);
}

export function UpgatesWebhookRequestToJSONTyped(value?: UpgatesWebhookRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event': value['event'],
        'ids': value['ids'],
    };
}

